import { useCachedApiCall } from '@hooks/apiCall';
import { orgUsersCache } from './orgUserStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 *
 * Explicit-fetch semantics: consumers control when to fetch (the
 * sharing settings only load users when the modal opens).
 */

/** Cache-backed org user list (explicit fetch). */
export const useOrgUsersEntry = (orgId?: string) =>
    useCachedApiCall(orgUsersCache, [orgId], [orgId], false);
